// lib
import React, { useContext, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'

import { DataContext } from '@aytm/app/stats/page/question-views/vq/Component'

// components
import { Dropdown } from 'primereact/dropdown'

import { itemTemplate, valueTemplate, optionGroupTemplate } from '@aytm/app/stats/page/components/lib/templates'

// styles
import style from '@aytm/app/stats/page/question-views/vq/styles/Component.module.scss'

const AnswerVariantOptions = ({ position, value, options, dropdownsRef, onSelectedChange }) => {
  const { disabled } = useContext(DataContext)

  const timer = useRef(null)

  const optionsRef = useRef(null)

  const onShow = useCallback(() => {
    if (!disabled) {
      const overlay = optionsRef.current.getOverlay()

      if (1 < position && null === value) {
        const key = dropdownsRef.current[position - 1]
        if (key != undefined && null !== key) {
          const item = overlay.querySelector(`[data-key="${key}"]`)

          if (item != undefined) {
            const parent = item.parentNode.parentNode.parentNode

            const parentRect = parent.getBoundingClientRect()
            const itemRect = item.parentNode.getBoundingClientRect()

            parent.scrollTop = itemRect.y - parentRect.y + parent.scrollTop
          }
        }
      }

      timer.current && clearTimeout(timer.current)
      timer.current = setTimeout(() => {
        overlay.classList.add('p-rendered')
      })
    }

    return () => timer.current && clearTimeout(timer.current)
  }, [position, value, dropdownsRef, disabled])

  return (
    <Dropdown
      ref={optionsRef}
      className={style.options}
      placeholder="Select..."
      value={value}
      options={options}
      optionValue="key"
      optionLabel="text"
      optionDisabled="disabled"
      optionGroupLabel="text"
      optionGroupChildren="items"
      itemTemplate={itemTemplate}
      valueTemplate={valueTemplate}
      optionGroupTemplate={optionGroupTemplate}
      filter={true}
      filterBy="search,text"
      filterPlaceholder="Search items"
      resetFilterOnHide={true}
      filterInputAutoFocus={false}
      fixedDropdownDir="bottom"
      disabled={disabled}
      onChange={disabled ? null : event => onSelectedChange(event.value)}
      onShow={onShow}
    />
  )
}

AnswerVariantOptions.propTypes = {
  position: PropTypes.number,
  value: PropTypes.any,
  options: PropTypes.array,
  dropdownsRef: PropTypes.any,
  onSelectedChange: PropTypes.func
}

AnswerVariantOptions.displayName = 'AnswerVariantOptions'

export default AnswerVariantOptions
